import { format, getTime, formatDistanceToNow } from 'date-fns';
import { isFinite } from 'lodash';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}
export const fDateN = (date) => {
  if (date instanceof Date) {
    return date.toLocaleString('en-US', { hour12: true });
  }
  return date.toDate().toLocaleString('en-US', { hour12: true });
};

export function fDateTimeM(date) {
  if (date instanceof Date) {
    return format(new Date(date), 'dd MMM yyyy HH:mm');
  }

  return format(new Date(date.toDate()), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export function convertHourToDay(hour) {
  const number = Number(hour);
  return Math.ceil(number / 24);
}

export function parseDate(date) {
  try {
    return date.toDate();
  } catch (e) {
    return date;
  }
}

export const formatDateToRequest = (dateString) => {
  const date = new Date(dateString);
  return date.toISOString().substring(0, 10);
};

/**
 * Incrementa un día a una fecha en formato de cadena 'YYYY-MM-DD'. Retorna la fecha actual hasta el final del día si dateString está vacío.
 *
 * @param {string} dateString - Una fecha en formato 'YYYY-MM-DD'.
 * @returns {string} Una nueva fecha en formato 'YYYY-MM-DD' con un día adicional.
 */
export function addOneDay(dateString) {
  if (!dateString) {
    const currentDate = new Date();
    currentDate.setUTCHours(23, 59, 59, 999);

    const currentYear = currentDate.getUTCFullYear();
    const currentMonth = String(currentDate.getUTCMonth() + 1).padStart(2, '0');
    const currentDay = String(currentDate.getUTCDate()).padStart(2, '0');

    return `${currentYear}-${currentMonth}-${currentDay}T23:59:59.999Z`;
  }

  // Extrae el año, mes y día de la cadena de fecha
  const [yearStr, monthStr, dayStr] = dateString.split('-');
  const year = parseInt(yearStr, 10);
  const month = parseInt(monthStr, 10) - 1; // Los meses van de 0 a 11 en JavaScript
  const day = parseInt(dayStr, 10);

  // Crea un objeto Date usando Date.UTC()
  const date = new Date(Date.UTC(year, month, day));

  // Agrega un día (24 horas) en milisegundos al objeto Date
  date.setUTCDate(date.getUTCDate() + 1);

  // Convierte el objeto Date actualizado de nuevo a una cadena en el formato 'YYYY-MM-DD'
  const newYear = date.getUTCFullYear();
  const newMonth = String(date.getUTCMonth() + 1).padStart(2, '0');
  const newDay = String(date.getUTCDate()).padStart(2, '0');

  // console.log({ dateString, newDay: `${newYear}-${newMonth}-${newDay}` });

  return `${newYear}-${newMonth}-${newDay}`;
}

export const addHoursToDate = (stringDate, hours, minutes) => {
  const date = new Date(stringDate);

  date.setHours(date.getHours() + hours);
  date.setMinutes(date.getMinutes() + minutes);

  const dateString = date.toISOString();

  return dateString;
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const dateString = (value, formatConfig = 'dd-MM-yyyy') => {
  if (!value) return '';
  return format(value, formatConfig);
};

export const isValidDate = (fecha) => fecha instanceof Date && isFinite(fecha.getTime());

export const formatGetDateOrFirestore = (dateRow, format = 'dd/MM/yyyy HH:mm') => {
  if (!dateRow) return '--';

  if (isValidDate(dateRow)) {
    return dateString(dateRow, format);
  }
  if (dateRow?.seconds) {
    return dateString(dateRow?.toDate(), format);
  }
  return '--';
};
